 export const skillsData = [
    'Python', 'Django', 'Graphql', 'Fastapi', 'RabbitMQ','Redis','Kubernetes', 'Docker','Celery','Milvus','LangChain','TensorFlow', 'spaCy', 'SciKit',  'HTML', 'CSS', 'Javascript', 'React','Expo' ,'Node JS', 'Nest JS', 'Git', 'MongoDB', 'PostgreSQL', 'MySQL'
]
